import Component from './campaign_table.vue'
export default Component
